import React, { useState } from "react";
import { serverAddr } from "../../networkConfig";

export default function SearchCoin({ onResult }) {
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSearch = async (value) => {
    setSearch(value);

    if (!value) return;

    try {
      setLoading(true);

      const response = await serverAddr.post(
        "/publisher/get_reco_details/",
        {
          page_no: 1,
          page_per_entries: 1,
          search: value
        }
      );

      const data =
        response.data?.data ||
        response.data?.result ||
        response.data ||
        [];

      if (data.length > 0) {
        const item = data[0];

        const formatted = {
          name: item.title || "",
          price: item.price,
          change: item.price_change,
          date: item.timestamp,
          confidenceScore: item.confidence_score || 2,
          markPrice: null
        };

        onResult(formatted); // send to parent
      }

    } catch (err) {
      console.error("Search error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="search-bar">
      <input
        type="text"
        placeholder="Search Coin e.g. Bitcoin"
        value={search}
        onChange={(e) => handleSearch(e.target.value)}
      />
      {loading && <span>Searching...</span>}
    </div>
  );
}